import React, { Component } from "react";
import AgendaDecision from "./AgendaDecision";
import IssueDecision from "./IssueDecision";

class DecisionAgendaSidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      issueListStatus,
      onChangeAgenda,
      agenda,
      agendaDetail,
      agendaDataList,
      agendaData,
      agendasAssociatedWithIssue
    } = this.props;
    return (
      <React.Fragment>
        {issueListStatus ? (
          <IssueDecision
            params={this.props.params}
            onChangeAgenda={onChangeAgenda}
            agendaDataList={agendaDataList}
            agenda={agenda}
            agendasAssociatedWithIssue={agendasAssociatedWithIssue}
          />
        ) : (
          <AgendaDecision
            agendaDetail={agendaDetail}
            listStatus={true}
            agendaData={agendaData}
          />
        )}
      </React.Fragment>
    );
  }
}

export default DecisionAgendaSidebar;
